import axios from 'axios';

const printApi = axios.create({
  baseURL: process.env.REACT_APP_PRINT_SERVER,
  withCredentials: false,
});

export default printApi;
